import { routesMap } from "../routesMap.js";
import { slugify } from "./slugify.js";
export function getRoute(key, lang) {
  return routesMap[key][lang];
}
export { slugify }; 